import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';

import { importsApi } from '../api/imports-api';

import { jobKeys } from './job-keys';

export function importJobsQueryOptions(storeId: string, params: ListParams) {
  return queryOptions({
    queryKey: jobKeys.importList(storeId, params),
    queryFn: () => importsApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useImportJobs(storeId: string, params: ListParams) {
  return useQuery(importJobsQueryOptions(storeId, params));
}
